/**
 * Repli affiché pendant le chargement à la demande d'une route découpée en
 * chunk (`React.lazy`, voir `routes/AppRouter.tsx`, Sprint 7 — réduction du
 * bundle). Volontairement sobre (un indicateur de rotation, pas de squelette
 * de page complet : on ne connaît pas encore la mise en page de la page
 * ciblée) et jamais un flash blanc.
 */
export function PageLoadingFallback() {
  return (
    <div className="flex min-h-[40vh] items-center justify-center">
      <div className="flex items-center gap-3 text-muted-foreground">
        <div
          className="h-5 w-5 animate-spin rounded-full border-2 border-current border-t-transparent"
          aria-hidden
        />
        <span className="text-sm">Chargement…</span>
      </div>
    </div>
  );
}
